export enum ColumnFieldType {
  String = 'String',
  HyperLink = 'HyperLink',
  Date = 'Date',
  Number = 'Number',
  Dropdown = 'Dropdown',
  Html = 'Html',
  TimeFrame = 'TimeFrame',
  Checkbox = 'Checkbox',
  ActionIcons = 'ActionIcons',
  FindControl = 'FindControl'
}
